






























































import { Component, Prop, Vue } from "vue-property-decorator";
import { User, UserGroupUser } from "@/services/users/types";
import { getUsers } from "@/services/users/usersService";
import { selectUsersFields } from "@/components/users/fields/selectUsersFields";
import i18n from "@/i18n";

    @Component
export default class SelectUsersModal extends Vue {
        users = [] as User[];
        fields = selectUsersFields;
        isBusy = false;
        sortBy = "name";
        sortDesc = false;
        selectedUsers = [] as User[];
        multiPicker = false;
        // filter options
        searchQuery = "";
        // lifecycle hooks

        // computed
        get filteredData() {
            return this.users && this.users
                .filter(x => this.searchQuery.length === 0 ||
                    (x.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                        x.email.toLowerCase().includes(this.searchQuery.toLowerCase())));
        }

        get title(): string {
            return i18n.t("users.selectUsers").toString();
        }

        // methods
        fetchData() {
            this.isBusy = true;
            getUsers().then(response => {
                this.users = response;
                this.isBusy = false;
            });
        }

        rowSelected(items: User[]) {
            this.selectedUsers = items;
        }

        open(multiPicker = false) {
            this.multiPicker = multiPicker;
            this.fetchData();
            this.$bvModal.show("modal-selectUser");
        }

        save() {
            this.$bvModal.hide("modal-selectUser");
            if (!this.selectedUsers || this.selectedUsers.length === 0) {
                return;
            }

            this.$emit("select", this.selectedUsers.map(user => {
                return {
                    userId: user.id,
                    roles: user.roles,
                    email: user.email,
                    name: user.name
                } as UserGroupUser;
            }));
        }

        resetState() {
            this.searchQuery = "";
            this.selectedUsers = [] as User[];
        }
}
